import React, { Component } from 'react';
import { Row, Col, Navbar, Form, Button } from 'react-bootstrap';
import Footer from '../components/Footer';
import '../css/style.css';
import '../components/Home';
import { translate } from "react-i18next";
import AuthenticationService from '../backend/AuthenticationService';


class DemoLoginLayout extends Component {

    constructor(props) {
        super(props);


        this.state = {
            code: ''
        };

        this.handleChange = this.handleChange.bind(this);
    }



    handleChange(e) {
        const { name, value } = e.target;
        if (AuthenticationService.registerUserDemo(value)) {
            // this.setState({ [name]: value });
        }
        this.setState({ [name]: value });
    }

    /*
        if (!AuthenticationService.isUserInAdminRole()) {
                return "ACCESS DENIED"
            }
            */


    render() {
        const { code } = this.state;
        const { t } = this.props;
        return (
            <div id="container">
                <div id="header">
                    <Navbar expand="lg"  >
                        <Navbar.Brand href="/" >
                            <span className="easy">easy</span><span className="event">Event</span>
                        </Navbar.Brand>
                    </Navbar>
                </div>
                <div id="body">
                    <Form>
                        <Form.Row className="justify-content-xl-center" >
                            <Col sm={3} className="my-1">
                                <Form.Control id="inlineFormInputName" placeholder="...is coming soon..." name="code" value={code} onChange={this.handleChange} />
                            </Col>

                            <Col xs="auto" className="my-1">
                                <Button type="submit" onClick={this.handleChange}>Submit</Button>
                            </Col>
                        </Form.Row>
                    </Form>

                </div>
               
            </div>
        );
    }

}

export default translate("translations")(DemoLoginLayout);